/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-30 09:27:19
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-24 19:52:49
 */
import { Form, Input, Button, Row, Col, notification, Space, Popover } from 'antd'
import React, { useEffect } from 'react'
import { QuestionCircleTwoTone, SearchOutlined } from '@ant-design/icons'
import { QingdouParams } from '../../services/qingdou'

export const ModalQuery = (props: {
  value?: QingdouParams
  onValueChange: (queries: QingdouParams) => void
  addSelectLine: () => void
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue(props.value)
  }, [props.value])

  return (
    <Form
      form={form}
      name='control-hooks'
      onFinish={(values) => {
        if (!values?.count) {
          notification.info({
            message: '请输入库存数量',
          })
        } else {
          props.onValueChange(values)
        }
      }}
    >
      <Row
        style={{
          marginBottom: 10,
        }}
        justify='space-between'
      >
        <Space>
          <Form.Item name='name' noStyle>
            <Input
              placeholder='请输入助记码和商品名称'
              allowClear
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item
            name='count'
            noStyle
            rules={[
              {
                pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                message: '请输入数字',
              },
            ]}
          >
            <Input
              onChange={() => form.submit()}
              style={{
                padding: 0,
                height: '32px',
              }}
              prefix={
                <span
                  style={{
                    display: 'inline-block',
                    // height: '34px',
                    // padding: '13px 12px',
                    // lineHeight: '8px',
                    background: '#F4F8FB',
                    marginLeft: '-1px',
                    marginRight: '7px',
                  }}
                >
                  库存数量 :
                </span>
              }
              addonAfter={
                <>
                  <Popover
                    placement='bottom'
                    title='列表展示小于等于输入库存数量的药品信息' 
                  >
                    <QuestionCircleTwoTone />
                  </Popover>
                </>
              }
            />
          </Form.Item>
          <Button
            type='primary'
            style={{ float: 'right' }}
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type="primary"
            style={{}}
            onClick={() => {
              props.addSelectLine()
            }}
          >
            添加选中行
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
